export default {
  // The agents service behind this app's own origin, prefix kept (ADR-0004 §2.1). The Docker image sets
  // FE_AGENTS_API_URL=/agents too: write_envs_to_file.sh rewrites this chunk at container start, dropping the default.
  VITE_AGENTS_API_URL: import.meta.env.VITE_AGENTS_API_URL ?? '/agents',
};
